// extracted by mini-css-extract-plugin
export var complianceStyles = "compliance-module--complianceStyles--htAX3";
export var termStyles = "compliance-module--termStyles--ab7At";
export var term1Styles = "compliance-module--term1Styles--KQVKS";
export var term2Styles = "compliance-module--term2Styles--LG91m";
export var term3Styles = "compliance-module--term3Styles--IMZOk";
export var videoStyles = "compliance-module--videoStyles--uq0Q1";
export var closeStyles = "compliance-module--closeStyles--2sM+Y";